const PUBLIC_FIRMWARE_BASE_URL = (
  process.env.REACT_APP_PUBLIC_FIRMWARE_BASE_URL || 'https://firmware.fluoraplant.com'
).replace(/\/+$/, '');

const OTA_MQTT_HOST = (
  process.env.REACT_APP_OTA_MQTT_FIRMWARE_HOST || 'firmware.fluoraplant.com'
).replace(/\/+$/, '');

const OTA_MQTT_MAX_NAME_LENGTH = 63;

function extractFilename(firmwarePathOrUrl: string): string {
  const value = firmwarePathOrUrl.trim().split('?')[0];
  return value.split('/').pop() || '';
}

export function normalizeFirmwareUrl(firmwarePathOrUrl: string): string {
  const value = firmwarePathOrUrl.trim();
  if (!value) {
    return '';
  }

  if (/^https?:\/\//i.test(value)) {
    return value;
  }

  if (value.startsWith('/bins/')) {
    return `${PUBLIC_FIRMWARE_BASE_URL}${value}`;
  }

  if (/^[A-Za-z0-9._-]+\.bin$/.test(value)) {
    return `${PUBLIC_FIRMWARE_BASE_URL}/bins/${value}`;
  }

  return value;
}

export function buildOtaMqttPreview(firmwarePathOrUrl: string): string {
  const filename = extractFilename(firmwarePathOrUrl);
  if (!filename.endsWith('.bin')) {
    return '';
  }

  const urlCandidates = [
    `${PUBLIC_FIRMWARE_BASE_URL}/bins/${filename}`,
    `${PUBLIC_FIRMWARE_BASE_URL.replace(/^https:/i, 'http:')}/bins/${filename}`,
    `http://${OTA_MQTT_HOST}/bins/${filename}`,
    `http://${OTA_MQTT_HOST}/b/${filename}`,
  ];

  for (const url of urlCandidates) {
    const command = `ota ${url}`;
    if (command.length <= OTA_MQTT_MAX_NAME_LENGTH) {
      return command;
    }
  }

  return `ota http://${OTA_MQTT_HOST}/b/${filename}`;
}
